<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <h6>
      <span *ngIf="finance.isReceive"
        >{{ "finances.receive" | translate }}
      </span>
      <span *ngIf="!finance.isReceive">{{ "finances.issue" | translate }}</span>
    </h6>

    <!-- <nb-select
      *ngIf="mode === 'new'"
      outline
      shape="semi-round"
      size="small"
      [status]="type === 'receive' ? 'info' : 'warning'"
      (selectedChange)="selectType($event)"
      [(ngModel)]="type"
    >
      <nb-option value="receive">
        {{ "finances.receive" | translate }}
      </nb-option>
      <nb-option value="issue"> {{ "finances.issue" | translate }} </nb-option>
    </nb-select> -->

    <div *ngIf="finance.type === 'receipt'">
      <h6 class="text-danger">{{ finance.customerName }}</h6>
    </div>
    <div *ngIf="finance.type === 'purchase'">
      <h6 class="text-danger">{{ finance.supplierName }}</h6>
    </div>
    <div *ngIf="finance.type === 'employee'">
      <h6 class="text-danger">{{ finance.employeeName }}</h6>
    </div>

    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>

  <nb-card-body [nbSpinner]="lockData" nbSpinnerStatus="danger">
    <div class="row">
      <div class="col-12 col-md-6">
        <form [formGroup]="diaForm">
          <div class="form-group">
            <label for="inputTitle" class="label">{{
              "common.date" | translate
            }}</label>
            <nb-form-field>
              <input
                nbInput
                shape="semi-round"
                placeholder="Chọn ngày"
                [nbDatepicker]="finDate"
                formControlName="issueDate"
                [(ngModel)]="issueDate"
              />
              <nb-datepicker
                style="width: 120px"
                #finDate
                format="dd/MM/yyyy"
              ></nb-datepicker>
            </nb-form-field>
          </div>

          <div class="form-group">
            <div class="label">
              <label>{{ "common.note" | translate }}</label>
            </div>

            <textarea
              nbInput
              fullWidth
              rows="5"
              id="inputDescription"
              class="form-control"
              formControlName="note"
              [(ngModel)]="finance.note"
            ></textarea>
          </div>

          <div class="form-group">
            <label class="label">
              Số tiền:
              <nb-toggle
                status="primary"
                size="small"
                labelPosition="right"
                [(ngModel)]="finance.isBankTransfer"
                formControlName="isBankTransfer"
              >
                <span>{{
                  finance.isBankTransfer ? "Chuyển khoản" : "Tiền mặt"
                }}</span>
              </nb-toggle>
            </label>

            <input
              *ngIf="finance.isReceive"
              type="text"
              nbInput
              shape="semi-round"
              class="form-control"
              placeholder="Nhập số tiền"
              [status]="finance.receiveAmount > 0 ? 'primary' : 'danger'"
              formControlName="amount"
              [(ngModel)]="finance.receiveAmount"
              [ngxNumberFormat]="formatCurrency"
            />
            <input
              *ngIf="!finance.isReceive"
              type="text"
              nbInput
              shape="semi-round"
              class="form-control"
              placeholder="Nhập số tiền"
              [status]="finance.issueAmount > 0 ? 'primary' : 'danger'"
              formControlName="amount"
              [(ngModel)]="finance.issueAmount"
              [ngxNumberFormat]="formatCurrency"
            />
          </div>
        </form>
      </div>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label class="label">
            <a (click)="openCatalog()" class="text-primary link">
              <nb-icon icon="menu-2-outline"></nb-icon>
              Nhóm
            </a>
          </label>
          <nb-form-field fullWidth>
            <button
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removeCatalog()"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <nb-select
              [(ngModel)]="finance.groupId"
              class="type-select"
              size="small"
              fullWidth
            >
              <nb-option *ngFor="let opt of groupFins" [value]="opt.id">{{
                opt.title
              }}</nb-option>
            </nb-select>
          </nb-form-field>
        </div>

        <div class="form-group">
          <label for="inputPersonName" class="label text-primary">
            <a
              *ngIf="!isEmployee"
              (click)="selectPerson()"
              class="text-primary link"
            >
              <nb-icon icon="menu-2-outline"></nb-icon>
              Chọn
              <span *ngIf="type === 'receive'">người nộp </span>
              <span *ngIf="type !== 'receive'">người nhận </span>
            </a>

            <nb-toggle
              *ngIf="
                mode === 'new' && !finance.customerId && !finance.supplierId
              "
              status="primary"
              size="tiny"
              labelPosition="right"
              [(ngModel)]="isEmployee"
            >
              <span>{{ isEmployee ? "Nội bộ" : "Tất cả" }}</span>
            </nb-toggle>
          </label>

          <nb-form-field *ngIf="!isEmployee" fullWidth>
            <button
              *ngIf="finance.personId && finance.personId !== ''"
              nbPrefix
              nbButton
              ghost
              size="small"
              status="danger"
              (click)="removePerson()"
            >
              <nb-icon icon="close-outline"></nb-icon>
            </button>
            <input
              [disabled]="finance.personId && finance.personId !== ''"
              type="text"
              nbInput
              fullWidth
              class="form-control"
              placeholder="Nhập tên"
              id="PersonName"
              [(ngModel)]="finance.personName"
            />
          </nb-form-field>

          <ngx-view-selection-object
            *ngIf="mode === 'new' && isEmployee"
            [shopId]="shopId"
            [objectType]="'employee'"
            [objectId]="finance.employeeId"
            [objectName]="finance.employeeName"
            [objects]="employees"
            (objectChange)="selectEmployee($event)"
          >
          </ngx-view-selection-object>
        </div>

        <div *ngIf="!isEmployee" class="form-group">
          <label for="inputPersonMobile" class="label"> SĐT </label>

          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            placeholder="Nhập SĐT"
            id="PersonMobile"
            [(ngModel)]="finance.personMobile"
          />
        </div>

        <div *ngIf="!isEmployee" class="form-group">
          <label for="inputPersonAddress" class="label">
            {{ "common.address" | translate }}
          </label>

          <input
            type="text"
            nbInput
            fullWidth
            class="form-control"
            placeholder="Nhập địa chỉ"
            id="PersonAddress"
            [(ngModel)]="finance.personAddress"
          />
        </div>

        <div class="form-group">
          <label class="label">{{ "common.tags" | translate }}</label>
          <nb-tag-list (tagRemove)="onTagRemove($event)">
            <nb-tag *ngFor="let tree of trees" [text]="tree" removable></nb-tag>
            <input
              type="text"
              nbTagInput
              (tagAdd)="onTagAdd($event)"
              fullWidth
            />
          </nb-tag-list>
        </div>
      </div>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button
      *ngIf="
        !finance.isPrint || (finance.isPrint && (user.admin || user.moderator))
      "
      nbButton
      status="primary"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="submit()"
    >
      <nb-icon icon="save-outline"></nb-icon>
      {{ "buttons.save" | translate }}
    </button>

    <button
      *ngIf="mode === 'edit'"
      nbButton
      status="success"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="print()"
    >
      <nb-icon icon="printer-outline"></nb-icon>
      {{ "buttons.print" | translate }}
    </button>

    <button
      *ngIf="mode === 'edit' && (user.admin || user.moderator)"
      nbButton
      status="danger"
      size="small"
      [disabled]="submitted || !diaForm.valid"
      [class.btn-pulse]="submitted"
      (click)="remove()"
    >
      <nb-icon icon="trash-2-outline"></nb-icon>
      {{ "buttons.delete" | translate }}
    </button>
  </nb-card-footer>
</nb-card>
